<template>
  <div class="user">
    <div class="common-form">{{$t('新增活动会场')}}</div>
    <div class="product-content">
      <el-form ref="form" :model="form" :rules="formRules" label-width="150px">
        <el-form-item :label="$t('活动标题')" prop="name" :rules="[{required: true,message: ' '}]">
          <el-input type="text" v-model="form.name" :placeholder="$t('请输入活动标题')" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item :label="$t('活动日期')">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="form.value1" type="daterange" value-format="yyyy-MM-dd" :range-separator="$t('至')"
              :start-placeholder="$t('开始日期')" :end-placeholder="$t('结束日期')">
            </el-date-picker>
          </div>
        </el-form-item>
        <div class="common-form">{{$t('礼包设置')}}</div>
        <el-form-item :label="$t('优惠券')">
          <el-button type="primary" @click="addCoupon()">{{$t('添加')}}</el-button>
          <el-table :data="tableData" style="width: 60%">
            <el-table-column prop="coupon_id" :label="$t('优惠券ID')">
            </el-table-column>
            <el-table-column prop="name" :label="$t('优惠券')">
            </el-table-column>
            <el-table-column :label="$t('数量')">
              <template slot-scope="scope">
                <el-form-item
                  :rules="[{ required: true, message: '1-9' },cprules]"
                  :prop="'coupon.' + scope.$index + '.coupon_num'">
                  <el-input type="number" v-model="form.coupon[scope.$index].coupon_num">
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="address" :label="$t('操作')">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click='delcoupon(scope.row)'>{{$t('删除')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <div class="common-form">{{$t('购买设置')}}</div>
        <el-form-item :label="$t('购买金额')" prop="money" :rules="[{required: true,message: ' '}]">
          <el-input type="number" v-model="form.money" class="max-w460">
            <template slot="append">€</template>
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('会员购买等级')">
          <el-radio-group v-model="form.is_grade">
            <el-radio :label="0">{{$t('不限')}}</el-radio>
            <el-radio :label="1">{{$t('指定等级')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('会员等级')" v-if="form.is_grade == 1">
          <el-select v-model="form.grade_ids" multiple :placeholder="$t('请选择')">
            <el-option v-for="(item,index) in Grade" :key="index" :label="item.name" :value="item.grade_id+''">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('购买次数')">
          <el-radio-group v-model="form.is_times">
            <el-radio :label="0">{{$t('不限')}}</el-radio>
            <el-radio :label="1">{{$t('限购')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="form.is_times == 1">
          <el-input type="number" v-model="form.times" class="max-w460">
            <template slot="prepend">{{$t('每人限购')}}</template>
            <template slot="append">{{$t('次')}}</template>
          </el-input>
        </el-form-item>
        <div class="common-form">{{$t('发放设置')}}</div>
        <el-form-item :label="$t('发放数量')" prop="total_num" :rules="[{required: true,message: ' '}]">
          <el-input type="number" v-model="form.total_num" :placeholder="$t('请输入发放数量')" class="max-w460"></el-input>
        </el-form-item>
      </el-form>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="info" @click="gotoBack">{{$t('返回')}}</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">{{$t('提交')}}</el-button>
      </div>
    </div>
    <!--选择优惠券-->
    <GetCoupon v-if="open_add" :open_add="open_add" @closeDialog="closeProductDialogFunc($event)">{{$t('选择优惠券弹出层')}}</GetCoupon>
  </div>
</template>
<script>
  import PackageApi from '@/api/package.js';
  import GetCoupon from '@/components/coupon/GetCoupon';
  import {
    formatModel
  } from '@/utils/base.js';
  export default {
    components: {
      /*选择优惠券件*/
      GetCoupon,
    },
    data() {
      var cprule = (rule, value, callback) => {
        if (value >=10 ||value <=0) {
          callback(new Error('1-9'));
        } else {
          callback();
        }
      };
      return {
        form: {
          coupon: [],
          is_times: 0,
          times: 0,
          is_grade: 0,
          grade_ids: '',
          value1: [],
          name: '',
          package_id: 0,
          total_num: '',
          money: '',
        },
        Grade: [],
        tableData: [],
        loading: false,
        open_add: false,
        formRules: {},
        /*左边长度*/
        formLabelWidth: '120px',
        cprules: {
          validator: cprule,
          trigger: 'blur'
        }
      };
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {
      /*添加优惠券*/
      addCoupon() {
        this.open_add = true;
      },
      /*关闭优惠券*/
      closeProductDialogFunc(e) {
        let self = this;
        self.open_add = e.openDialog;
        if (e.type == 'success') {
          if (self.form.coupon.length < 1) {
            self.form.coupon.push({
              coupon_id: e.params.coupon_id,
              coupon_num: 1
            });
            self.tableData.push(e.params);
            console.log(self.form.coupon)
          } else {
            let flag = true;
            self.form.coupon.forEach((item, index) => {
              if (item.coupon_id == e.params.coupon_id) {
                flag = false
              }
            })
            if (flag) {
              self.form.coupon.push({
                coupon_id: e.params.coupon_id,
                coupon_num: 1
              });
              self.tableData.push(e.params);
            } else {
              self.$message.error(self.$t('请勿重复添加'));
            }
          }
        }
      },
      /*获取数据*/
      getData() {
        let self = this;
        let id = self.$route.query.package_id;
        PackageApi.getData({
          id: id
        }, true).then(data => {
          self.form = formatModel(self.form, data.data.data);
          console.log(self.form)
          self.Grade = data.data.list;
          if (data.data.data.coupon_list) {
            self.form.coupon = JSON.parse(self.form.coupon)
            self.tableData = data.data.data.coupon_list;
          } else {
            self.tableData = [];
            self.form.coupon = [];
          }
        }).catch(error => {});
      },
      delcoupon(item) {
        let self = this;
        let n = self.tableData.indexOf(item);
        self.tableData.splice(n, 1);
        self.form.coupon.splice(n, 1);
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        let form  = JSON.parse(JSON.stringify(self.form));
        if(self.form.coupon.length<=0){
          this.$message.error(self.$t('至少选择一个优惠券'));
        }
        self.$refs.form.validate((valid) => {
          if (valid) {
            form.coupon = JSON.stringify(form.coupon);
            self.loading = true;
            PackageApi.EditPackage(form, true).then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.$router.push('/plus/package/index');
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },
      /*返回上一页面*/
      gotoBack() {
        this.$router.back(-1);
      },
      max10(e) {
        if (e.target.value >= 10) {
          e.target.value = 10
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/marketingtool/package/edit.vue